<template>
  <div class="page-container">
    <div class="page-header">
      <h2 class="page-title">小红书小程序管理</h2>
      <p class="page-subtitle">连接小红书生态，拓展社交电商新渠道</p>
    </div>

    <div class="auth-layout">
      <!-- 左侧注册板块 -->
      <div class="auth-card register-card">
        <div class="card-header">
          <div class="icon-wrapper">
            <el-icon>
              <plus />
            </el-icon>

          </div>
          <div class="header-content">
            <h3 class="auth-title">注册小红书小程序</h3>
            <p class="auth-desc">还没有小红书小程序账号？请先注册</p>
          </div>
        </div>

        <div class="card-body">
          <div class="auth-status">
            <p class="tip-text">已有小红书专业号可直接创建小程序，没有则需注册</p>
            <el-button type="success" @click="goToRegister" class="auth-button">
              <el-icon>
                <Link />

              </el-icon>

              前往注册小程序
            </el-button>
          </div>
        </div>
      </div>

      <!-- 右侧绑定板块 -->
      <div class="auth-card bind-card">
        <div class="card-header">
          <div class="icon-wrapper">
            <el-icon>
              <connection />
            </el-icon>

          </div>
          <div class="header-content">
            <h3 class="auth-title">绑定小红书小程序</h3>
            <p class="auth-desc">绑定后您将解锁小红书会员制营销功能</p>
          </div>
        </div>

        <div class="card-body">
          <div class="auth-status">
            <p class="tip-text">请确保小程序认证主体和专业号主体一致</p>
            <el-button type="primary" @click="showBindDialog" class="auth-button" v-if="!isBound">
              <el-icon>
                <key />
              </el-icon>

              立即绑定小红书小程序
            </el-button>

            <div v-else class="bound-actions">
              <el-button @click="showConfig"><el-icon>
                  <View />
                </el-icon>
                查看配置</el-button>
              <el-button type="primary" @click="downloadCode"><el-icon>
                  <download />
                </el-icon>
                下载代码</el-button>
              <el-button type="success" @click="uploadCode" :loading="isUploading" :disabled="!downloadUrl">
                <el-icon>
                  <upload />
                </el-icon>
                在线上传
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 绑定弹窗 -->
    <el-dialog title="绑定小红书小程序" v-model="bindDialogVisible" width="600px" class="elegant-dialog">
      <el-form :model="bindForm" label-width="120px" class="elegant-form">
        <el-form-item label="小程序ID" required>
          <el-input v-model="bindForm.app_id" placeholder="请输入小红书小程序ID">
            <el-icon>
              <document />
            </el-icon>

          </el-input>
        </el-form-item>
        <el-form-item label="小程序密钥" required>
          <el-input v-model="bindForm.app_secret" placeholder="请输入小红书小程序密钥" show-password>

            <el-icon>
              <lock />
            </el-icon>

          </el-input>
        </el-form-item>
        <el-form-item label="上传密钥" required>
          <el-input v-model="bindForm.upload_key" placeholder="请输入上传密钥">
            <el-icon>
              <upload />
            </el-icon>
          </el-input>
        </el-form-item>

        <!-- 在原有弹窗的表单中添加 -->
        <el-form-item label="支付状态" required>
          <el-select v-model="bindForm.pay_status" placeholder="请选择支付状态" class="full-width-select">
            <el-option label="关闭所有支付" :value="1"></el-option>
            <el-option label="开启通用支付" :value="2"></el-option>
            <el-option label="开启本地支付" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="物流接口">
          <el-input v-model="bindForm.appcode" placeholder="请输入物流接口（appcode）">
            <el-icon>
              <key />
            </el-icon>
          </el-input>
        </el-form-item>

        <el-form-item label="认证状态" required>
          <el-select v-model="bindForm.status" placeholder="请选择认证状态" class="full-width-select">
            <el-option label="待认证" :value="1"></el-option>
            <el-option label="已认证" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="bindDialogVisible = false" class="dialog-btn">取消</el-button>
        <el-button type="primary" @click="confirmBind" class="dialog-btn">确定绑定</el-button>
      </template>
    </el-dialog>

    <!-- 查看配置弹窗 -->
    <!-- 修改后的查看配置弹窗 -->
    <el-dialog title="小程序配置信息" v-model="configDialogVisible" width="800px" class="elegant-dialog">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="基本配置" name="basic">
          <el-form :model="currentConfig" label-width="120px" class="elegant-form">
            <el-form-item label="小程序ID">
              <el-input v-model="currentConfig.app_id" readonly>
                <template #prefix>
                  <el-icon>
                    <document />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="小程序密钥">
              <el-input v-model="currentConfig.app_secret" readonly show-password>
                <template #prefix>
                  <el-icon>
                    <lock />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="上传密钥">
              <el-input v-model="currentConfig.upload_key" readonly>
                <template #prefix>
                  <el-icon>
                    <upload />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="支付状态">
              <el-input :value="currentConfig.pay_status === 1 ? '关闭所有支付' :
                currentConfig.pay_status === 3 ? '开启本地支付' : '开启通用支付'" readonly>
                <template #prefix>
                  <el-icon>
                    <wallet />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="物流接口">
              <el-input v-model="currentConfig.appcode" readonly>
                <template #prefix>
                  <el-icon>
                    <connection />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="认证状态">
              <el-input :value="currentConfig.status === 1 ? '待认证' : '已认证'" readonly>
                <template #prefix>
                  <el-icon><success-filled /></el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="类目设置" name="category">
          <div class="category-container">
            <!-- 已选类目展示 -->
            <div class="selected-categories">
              <div class="section-header">
                <h4>已选类目</h4>
                <el-tag type="info" size="small">{{ cachedCategories.length }}个类目</el-tag>
              </div>

              <el-button size="small" type="danger" @click="clearAllCategories"
                :disabled="cachedCategories.length === 0" icon="Delete">
                清除所有
              </el-button>


              <el-table :data="cachedCategories" border style="width: 100%" empty-text="暂无已选类目" max-height="300">
                <el-table-column prop="name" label="类目名称" width="280" />
                <el-table-column prop="category_id" label="类目ID" width="270" />
                <el-table-column label="操作" width="150">
                  <template #default="scope">
                    <el-button size="small" type="danger" @click="removeCategory(scope.row.category_id)" icon="Delete">
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 获取全部类目 -->
            <div class="all-categories">
              <div class="section-header">
                <h4>全部类目</h4>
                <div>
                  <el-input v-model="categorySearch" placeholder="搜索类目名称" style="width: 200px; margin-right: 10px;"
                    clearable @clear="handleSearchClear" @keyup.enter="handleSearch">
                    <template #prefix>
                      <el-icon>
                        <Search />
                      </el-icon>
                    </template>
                  </el-input>
                  <el-button type="primary" size="small" @click="fetchAllCategories" :loading="isLoadingCategories"
                    icon="Refresh">
                    获取全部类目
                  </el-button>
                </div>
              </div>

              <el-table :data="filteredCategories" border style="width: 100%" empty-text="点击上方按钮获取类目列表"
                max-height="300">
                <el-table-column prop="name" label="类目名称" width="280" />
                <el-table-column prop="category_id" label="类目ID" width="270" />
                <el-table-column label="操作" width="150">
                  <template #default="scope">
                    <el-button size="small" type="primary" @click="addCategory(scope.row)"
                      :disabled="isCategorySelected(scope.row.category_id)" icon="Plus">
                      添加
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <template #footer>
        <el-button @click="configDialogVisible = false" class="dialog-btn">关闭</el-button>
        <el-button v-if="activeTab === 'basic'" @click="editConfig" class="dialog-btn">
          编辑配置
        </el-button>
        <el-button v-if="activeTab === 'category'" type="primary" @click="saveCategories" class="dialog-btn"
          :loading="isSaving" :disabled="cachedCategories.length === 0">
          保存设置
        </el-button>
      </template>
    </el-dialog>
  </div>


  <el-dialog title="小程序构建进度" v-model="buildDialogVisible" width="700px" :before-close="handleBuildClose"
    class="build-dialog">
    <div class="build-progress">
      <!-- 进度条 -->
      <el-progress :percentage="buildProgress" :status="buildStatus" :stroke-width="16" :text-inside="true" />

      <!-- 阶段日志 -->
      <div class="log-container" ref="logContainer" v-if="buildLogs.length > 0">
        <div v-for="(log, index) in buildLogs" :key="index" class="log-item" :class="{
          'log-success': log.status === 'success',
          'log-error': log.status === 'error',
          'log-warning': log.status === 'warning'
        }">
          <div class="log-header">
            <span class="log-stage">{{ log.stage }}</span>
            <span class="log-percent">{{ log.percentage }}%</span>
            <span class="log-time">{{ log.timestamp }}</span>
          </div>
          <div class="log-message">{{ log.message }}</div>
          <div v-if="log.details" class="log-details">{{ log.details }}</div>
          <div v-if="log.output" class="log-output">
            <pre>{{ log.output }}</pre>
          </div>
        </div>
        <!-- 构建成功提示 -->
        <div v-if="buildComplete" class="success-panel">
          <el-alert title="构建成功!" type="success" :closable="false" show-icon class="success-alert" />
          <div class="domain-card">
            <div class="domain-content">
              <el-icon class="link-icon">
                <Link />
              </el-icon>
              <div class="domain-info">
                <p class="tip-text">请将以下域名配置到小红书小程序后台：</p>
                <p class="domain-url">{{ currentDomain }}</p>
              </div>
            </div>
            <img :src="require('@/assets/xhsym.png')" alt="配置示例" class="demo-image" />
          </div>

          <div class="link-group">
            <el-link type="primary" :underline="false" href="https://miniapp.xiaohongshu.com/home" target="_blank"
              class="link-item">
              <el-icon class="link-icon">
                <Promotion />
              </el-icon>
              小红书小程序官网
            </el-link>

            <el-link type="info" :underline="false" href="https://miniapp.xiaohongshu.com/doc/DC514746" target="_blank"
              class="link-item">
              <el-icon class="link-icon">
                <Tools />
              </el-icon>
              开发工具下载
            </el-link>

            <el-link type="info" :underline="false"
              href="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/video/20250418/202504182048150b13e4354.mp4"
              target="_blank" class="link-item">
              <el-icon class="link-icon">
                <Tools />
              </el-icon>
              视频教程下载
            </el-link>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <el-button @click="cancelBuild" :disabled="!buildCancelable" class="dialog-btn">
        取消构建
      </el-button>
      <el-button type="primary" @click="downloadBuildResult" :disabled="!buildComplete" class="dialog-btn">
        下载代码
      </el-button>
    </template>
  </el-dialog>

  <!-- 上传成功弹窗 -->
  <el-dialog title="上传成功" v-model="uploadSuccessVisible" width="600px" class="upload-success-dialog">
    <div class="upload-success-content">
      <el-result icon="success" title="上传成功" subTitle="小程序代码已成功上传到小红书平台">
        <template #extra>
          <p class="publish-tip">请访问以下链接发布代码：</p>
          <el-link type="primary" :href="publishUrl" target="_blank" class="publish-link">
            {{ publishUrl }}
          </el-link>

        </template>
      </el-result>
    </div>

    <template #footer>
      <el-button type="primary" @click="openPublishPage" class="dialog-btn">
        立即前往发布
      </el-button>
      <el-button @click="uploadSuccessVisible = false" class="dialog-btn">
        关闭
      </el-button>
    </template>
  </el-dialog>
</template>

<script>

import axios from 'axios';
import config from '@/config.js'; // 引入配置文件
import Cookies from 'js-cookie';  // 新增引入
import {
  Plus,
  Connection,
  Link,
  Key,
  View,
  Download,
  Upload,
  Document,
  Lock,
  SuccessFilled,
  Wallet,
  Search
} from '@element-plus/icons-vue'

export default {

  components: {
    Plus,
    Connection,
    Link,
    Key,
    View,
    Download,
    Upload,
    Document,
    Lock,
    SuccessFilled,
    Wallet,
    Search
  },
  data() {
    return {
      isBound: false,
      isLoading: false,
      bindDialogVisible: false,
      configDialogVisible: false,
      bindForm: {
        app_id: '',
        app_secret: '',
        upload_key: '',
        app_url: '',
        status: 1,
        pay_status: 1,  // 新增默认值
        appcode: '',     // 新增
        remark: ''
      },
      isUploading: false,
      uploadSuccessVisible: false,
      publishUrl: '',
      uploadDetails: [],
      buildDialogVisible: false,
      buildProgress: 0,
      buildStatus: '', // success/exception/warning
      buildLogs: [],
      buildComplete: false,
      buildCancelable: true,
      buildController: null, // 用于取消请求的AbortController
      downloadUrl: '', // 构建完成后下载链接
      currentConfig: {},
      activeTab: 'basic',
      cachedCategories: [],
      allCategories: [],
      filteredCategories: [],
      categorySearch: '',
      isLoadingCategories: false,
      isSaving: false
    }
  },

  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },

  mounted() {
    this.loadMiniConfig()
  },
  methods: {
    async uploadCode() {
      try {
        // 确保有可用的下载链接
        if (!this.downloadUrl) {
          this.$message.warning('请先构建并获取代码下载链接');
          return;
        }

        // 确认上传
        await this.$confirm('确定要将小程序代码上传到小红书平台吗？', '确认上传', {
          type: 'warning'
        });

        this.isUploading = true;

        // 获取配置信息
        const account = this.userInfo.account;
        const configResponse = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'get_config',
          account: account
        });

        if (!configResponse.data.success) {
          throw new Error('获取配置失败: ' + (configResponse.data.message || ''));
        }

        const { version } = configResponse.data.data;

        // 准备上传数据
        const uploadData = {
          appid: this.currentConfig.app_id,
          token: this.currentConfig.upload_key,
          version: version,
          desc: 'update',
          code_url: this.downloadUrl
        };

        // 调用上传接口
        const uploadResponse = await axios.post(
          'https://db.juzhendi.com/auth/minidb/xhsmini_sc/upload_with_download.php',
          uploadData,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        // 处理响应
        if (uploadResponse.data.status === 'success') {
          // 设置发布链接
          this.publishUrl = `https://miniapp.xiaohongshu.com/mini/${this.currentConfig.app_id}/versions`;
          // 保存上传详情
          this.uploadDetails = uploadResponse.data.detail || [];
          // 显示成功弹窗
          this.uploadSuccessVisible = true;

          // 记录上传日志
          this.buildLogs.push({
            stage: 'upload',
            message: '代码上传成功',
            timestamp: new Date().toLocaleTimeString(),
            status: 'success',
            details: '请前往小红书平台发布代码'
          });
        } else {
          throw new Error(uploadResponse.data.message || '上传失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('上传失败: ' + error.message);
          console.error('上传失败:', error);

          // 记录上传失败日志
          this.buildLogs.push({
            stage: 'upload',
            message: error.message,
            timestamp: new Date().toLocaleTimeString(),
            status: 'error'
          });
        }
      } finally {
        this.isUploading = false;
      }
    },

    // 打开发布页面
    openPublishPage() {
      window.open(this.publishUrl, '_blank');
      this.uploadSuccessVisible = false;
    },

    async loadMiniConfig() {
      try {
        this.isLoading = true
        const { data } = await axios.get(`${config.BASE_URL}/shop/api/mini_config.php`, {
          params: {
            store_id: this.userInfo.id,
            agent_id: this.userInfo.agent_id
          }
        })

        if (data.code === 200) {
          this.isBound = true
          this.currentConfig = data.data
          // 同步表单数据
          this.bindForm = {
            app_id: data.data.app_id,
            app_secret: data.data.app_secret,
            upload_key: data.data.upload_key,
            app_url: data.data.app_url,
            status: data.data.status,
            remark: data.data.remark
          }
        } else {
          this.isBound = false
        }
      } catch (error) {
        this.$message.error('加载配置失败')
      } finally {
        this.isLoading = false
      }
    },
    // 前往注册页面
    goToRegister() {
      window.open('https://miniapp.xiaohongshu.com/home', '_blank')
    },
    // 显示绑定弹窗
    showBindDialog() {
      this.bindDialogVisible = true
    },
    // 确认绑定
    async confirmBind() {
      try {
        const payload = {
          ...this.bindForm,
          store_id: this.userInfo.id,
          agent_id: this.userInfo.agent_id,
          app_url: window.location.origin

        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/mini_config.php`,
          payload
        )

        if (data.code === 200) {
          this.$message.success('绑定成功')
          this.isBound = true
          this.bindDialogVisible = false
          await this.loadMiniConfig()
        } else {
          this.$message.error(data.message || '绑定失败')
        }
      } catch (error) {
        this.$message.error('请求失败，请检查网络')
      }
    },
    async handleUnbind() {
      try {
        await this.$confirm('确定要解除绑定吗？这将导致小程序功能不可用', '警告', {
          type: 'warning'
        })

        const { data } = await axios.delete(`${config.BASE_URL}/shop/api/mini_config.php`, {
          data: {
            store_id: this.userInfo.id,
            agent_id: this.userInfo.agent_id
          }
        })

        if (data.code === 200) {
          this.$message.success('已解除绑定')
          this.isBound = false
          this.currentConfig = {}
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('解除绑定失败')
        }
      }
    },
    // 加载缓存类目
    async loadCachedCategories() {
      try {
        const { data } = await axios.get(`${config.BASE_URL}/shop/api/XhsCategoryApi.php`, {
          params: {
            action: 'get_cache',
            mini_id: this.currentConfig.id
          }
        });

        if (data.success) {
          this.cachedCategories = data.data || [];
        }
      } catch (error) {
        this.$message.error('获取缓存类目失败');
        console.error(error);
      }
    },

    // 获取全部类目
    async fetchAllCategories() {
      this.isLoadingCategories = true;
      try {
        const { data } = await axios.get(`${config.BASE_URL}/shop/api/XhsCategoryApi.php`, {
          params: {
            action: 'get_categories',
            mini_id: this.currentConfig.id
          }
        });

        if (data.success) {
          this.allCategories = data.data || [];
          this.filteredCategories = [...this.allCategories];
          this.$message.success('获取类目成功');
        } else {
          this.$message.error(data.message || '获取类目失败');
        }
      } catch (error) {
        this.$message.error('请求失败，请检查网络');
        console.error(error);
      } finally {
        this.isLoadingCategories = false;
      }
    },

    // 添加类目
    addCategory(category) {
      if (!this.isCategorySelected(category.category_id)) {
        this.cachedCategories.push({ ...category });
        this.$message.success(`已添加类目: ${category.name}`);
      }
    },

    // 移除类目
    removeCategory(categoryId) {
      const index = this.cachedCategories.findIndex(item => item.category_id === categoryId);
      if (index !== -1) {
        this.cachedCategories.splice(index, 1);
        this.$message.success('已移除类目');
      }
    },

    // 检查类目是否已选
    isCategorySelected(categoryId) {
      return this.cachedCategories.some(item => item.category_id === categoryId);
    },

    // 保存类目设置
    async saveCategories() {
      this.isSaving = true;
      try {
        const { data } = await axios.post(`${config.BASE_URL}/shop/api/XhsCategoryApi.php`, {
          action: 'batch_update',
          mini_id: this.currentConfig.id,
          categories: this.cachedCategories
        });

        if (data.success) {
          this.$message.success('类目设置保存成功');
          this.configDialogVisible = false;
          await this.loadCachedCategories(); // 重新加载缓存
        } else {
          this.$message.error(data.message || '保存失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存类目设置失败');
      } finally {
        this.isSaving = false;
      }
    },

    async clearAllCategories() {
      try {
        await this.$confirm('确定要清除所有已选类目吗？', '提示', {
          type: 'warning'
        });

        const { data } = await axios.post(`${config.BASE_URL}/shop/api/XhsCategoryApi.php`, {
          action: 'batch_delete',
          mini_id: this.currentConfig.id
        });

        if (data.success) {
          this.$message.success('已清除所有类目');
          this.cachedCategories = [];
        } else {
          this.$message.error(data.message || '清除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('清除类目失败');
        }
      }
    },

    // 搜索类目
    handleSearch() {
      if (!this.categorySearch) {
        this.filteredCategories = [...this.allCategories];
        return;
      }
      this.filteredCategories = this.allCategories.filter(item =>
        item.name.includes(this.categorySearch)
      );
    },

    // 清除搜索
    handleSearchClear() {
      this.filteredCategories = [...this.allCategories];
    },


    // 显示配置
    showConfig() {
      this.activeTab = 'basic';
      this.configDialogVisible = true;
      this.loadCachedCategories();
    },
    // 编辑配置
    editConfig() {
      this.bindForm = { ...this.currentConfig }
      this.configDialogVisible = false
      this.bindDialogVisible = true
    },
    async startBuild() {
      try {
        // 重置构建状态
        this.buildDialogVisible = true;
        this.buildProgress = 0;
        this.buildStatus = '';
        this.buildLogs = [];
        this.buildComplete = false;
        this.downloadUrl = '';
        this.buildCancelable = true;

        // 获取配置信息
        const account = this.userInfo.account;
        const configResponse = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'get_config',
          account: account
        });

        if (!configResponse.data.success) {
          throw new Error('获取配置失败: ' + (configResponse.data.message || ''));
        }
        // 获取当前完整域名（带协议）
        const currentDomain = window.location.origin;

        const { mini_id, version, auth_url } = configResponse.data.data;

        // 解析配置的域名
        const configDomain = new URL(auth_url).origin;

        // 判断域名是否需要替换
        const finalDomain = configDomain === currentDomain ? auth_url : currentDomain;


        // 准备构建参数
        const params = new URLSearchParams({
          domain: finalDomain,
          mini_id: mini_id,
          version: version,
          appid: this.currentConfig.app_id // 添加小红书小程序ID
        });
        // 存储当前使用的域名用于显示
        this.currentDomain = finalDomain;

        // 创建可取消的请求
        this.buildController = new AbortController();

        // 调用流式接口
        const response = await fetch(`https://db.juzhendi.com/auth/minidb/xhsmini_dm/ls_build.php?${params}`, {
          signal: this.buildController.signal
        });

        if (!response.ok) {
          throw new Error(`HTTP错误: ${response.status}`);
        }

        // 处理流式响应
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });

          // 处理可能的多条消息
          while (buffer.includes('\n\n')) {
            const messageEnd = buffer.indexOf('\n\n');
            const message = buffer.substring(0, messageEnd);
            buffer = buffer.substring(messageEnd + 2);

            // 跳过空消息和注释
            if (!message || message.startsWith(':')) continue;

            try {
              // 解析SSE格式
              if (message.startsWith('data:')) {
                const data = JSON.parse(message.substring(5).trim());

                // 更新进度
                if (data.percentage) {
                  this.buildProgress = data.percentage;
                }

                // 添加日志
                this.buildLogs.push({
                  ...data,
                  timestamp: new Date().toLocaleTimeString()
                });

                // 滚动到底部
                this.$nextTick(() => {
                  const container = this.$refs.logContainer
                  if (container?.scrollHeight) {
                    container.scrollTop = container.scrollHeight
                  }
                });

                // 处理完成状态
                if (data.stage === 'complete') {
                  this.buildComplete = true;
                  this.buildCancelable = false;
                  this.buildStatus = 'success';
                  this.downloadUrl = data.download_url;
                } else if (data.event === 'error') {
                  this.buildStatus = 'exception';
                  this.buildCancelable = false;
                }
              }
            } catch (e) {
              console.error('解析消息失败:', e, message);
            }
          }
        }

        if (!this.buildComplete && !this.buildStatus) {
          throw new Error('构建未完成');
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.buildStatus = 'exception';
          this.buildLogs.push({
            stage: 'error',
            message: error.message,
            timestamp: new Date().toLocaleTimeString(),
            status: 'error'
          });
        }
        this.buildCancelable = false;
      }
    },

    cancelBuild() {
      if (this.buildController) {
        this.buildController.abort();
        this.buildCancelable = false;
        this.buildLogs.push({
          stage: 'cancelled',
          message: '构建已取消',
          timestamp: new Date().toLocaleTimeString(),
          status: 'warning'
        });
      }
    },

    downloadBuildResult() {
      if (this.downloadUrl) {
        window.open(this.downloadUrl, '_blank');
      } else {
        this.$message.error('没有可用的下载链接');
      }
    },

    handleBuildClose(done) {
      if (this.buildComplete || !this.buildCancelable) {
        done();
      } else {
        this.$confirm('构建仍在进行中，确定要关闭吗？', '提示', {
          type: 'warning'
        }).then(() => {
          this.cancelBuild();
          done();
        }).catch(() => { });
      }
    },

    // 修改原来的downloadCode方法
    async downloadCode() {
      try {
        this.$message.info('准备构建小程序代码...');
        await this.startBuild();
      } catch (error) {
        this.$message.error('初始化构建失败: ' + error.message);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ed 100%);
  min-height: 100vh;
}

.page-header {
  padding: 30px 40px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;

  .page-title {
    margin: 0;
    color: #333;
    font-size: 28px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .page-subtitle {
    margin: 8px 0 0;
    color: #666;
    font-size: 16px;
    font-weight: 400;
  }
}

.auth-layout {
  display: flex;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.auth-card {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  }
}

.register-card {
  border-top: 5px solid #67C23A;

  .icon-wrapper {
    background: rgba(103, 194, 58, 0.1);
    color: #67C23A;
  }
}

.bind-card {
  border-top: 5px solid #409EFF;

  .icon-wrapper {
    background: rgba(64, 158, 255, 0.1);
    color: #409EFF;
  }
}

.card-header {
  display: flex;
  align-items: center;
  padding: 25px;
  border-bottom: 1px solid #f0f0f0;

  .icon-wrapper {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    font-size: 24px;
  }

  .header-content {
    flex: 1;
  }
}

.auth-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 5px;
  font-weight: 600;
}

.auth-desc {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.card-body {
  padding: 25px;
}

.auth-status {
  margin-top: 10px;
  padding: 20px;
  background: #f9fafc;
  border-radius: 8px;
  border: 1px dashed #e0e3e9;
}

.tip-text {
  color: #888;
  font-size: 13px;
  margin: 8px 0 15px;
  line-height: 1.5;
}

.auth-button {
  margin-top: 10px;
  width: 100%;
  height: 44px;
  font-size: 15px;
  letter-spacing: 0.5px;
}

.bound-actions {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .el-button {
    flex: 1;
    min-width: 120px;
    height: 40px;
  }
}

/* 对话框样式 */
.elegant-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #f0f0f0;
    padding: 20px 25px;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  .el-dialog__body {
    padding: 25px;
  }

  .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 15px 25px;
  }
}

.elegant-form {
  .el-form-item {
    margin-bottom: 22px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 10px;
    color: #999;
  }
}

.full-width-select {
  width: 100%;
}

.dialog-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .auth-layout {
    flex-direction: column;
  }

  .auth-card {
    padding: 0;
  }

  .card-header {
    padding: 20px;
  }

  .card-body {
    padding: 20px;
  }
}

/* 构建弹窗样式 */
.build-dialog {
  .el-dialog__body {
    padding: 0;
  }
}

.build-progress {
  padding: 20px;

  .el-progress {
    margin-bottom: 20px;
  }
}

.log-container {
  height: 400px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
}

.log-item {
  margin-bottom: 15px;
  padding: 10px;
  border-left: 3px solid #dcdfe6;
  background-color: #fafafa;

  &.log-success {
    border-left-color: #67c23a;
    background-color: #f0f9eb;
  }

  &.log-error {
    border-left-color: #f56c6c;
    background-color: #fef0f0;
  }

  &.log-warning {
    border-left-color: #e6a23c;
    background-color: #fdf6ec;
  }
}

.log-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 13px;

  .log-stage {
    font-weight: bold;
    color: #333;
  }

  .log-percent {
    color: #409eff;
  }

  .log-time {
    color: #909399;
  }
}

.log-message {
  margin: 5px 0;
  color: #606266;
}

.log-details {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.log-output pre {
  margin: 5px 0 0;
  padding: 5px;
  background: #2c3e50;
  color: #f8f8f2;
  border-radius: 3px;
  font-size: 12px;
  overflow-x: auto;
}

// 添加样式
.success-panel {
  margin-top: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;

  .success-alert {
    margin-bottom: 20px;
  }

  .domain-card {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

    .domain-content {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .link-icon {
        font-size: 24px;
        color: #67C23A;
        margin-right: 15px;
      }

      .domain-info {
        flex: 1;

        .tip-text {
          color: #606266;
          margin-bottom: 8px;
        }

        .domain-url {
          font-size: 16px;
          color: #409EFF;
          font-weight: 500;
          word-break: break-all;
        }
      }
    }

    .demo-image {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #ebeef5;
      margin-top: 15px;
    }
  }

  .link-group {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;

    .link-item {
      padding: 12px 25px;
      border-radius: 6px;
      transition: all 0.3s;

      &:hover {
        background: rgba(64, 158, 255, 0.1);
        transform: translateY(-2px);
      }

      .link-icon {
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
}

@media (max-width: 576px) {
  .page-header {
    padding: 20px;
  }

  .bound-actions {
    flex-direction: column;

    .el-button {
      width: 100%;
    }
  }
}

.el-icon.wallet {
  color: #e6a23c;
}

.el-icon.connection {
  color: #409eff;
}

.category-container {
  padding: 0 20px;

  .selected-categories,
  .all-categories {
    margin-bottom: 25px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      h4 {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        margin: 0;
        display: flex;
        align-items: center;

        :deep(.el-tag) {
          margin-left: 10px;
        }
      }
    }
  }

  .el-table {
    margin-top: 10px;

    :deep(.el-table__empty-block) {
      min-height: 100px;
    }
  }
}

.elegant-dialog {
  .el-dialog__body {
    padding: 0;
    max-height: 70vh;
    overflow-y: auto;

    .el-tabs {
      :deep(.el-tabs__content) {
        padding: 20px;
      }
    }
  }
}

.dialog-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
}

.selected-categories .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .category-container {
    padding: 0 10px;

    .section-header {
      flex-direction: column;
      align-items: flex-start !important;

      &>div {
        margin-top: 10px;
        width: 100%;

        .el-input {
          width: 100% !important;
          margin-right: 0 !important;
          margin-bottom: 10px;
        }

        .el-button {
          width: 100%;
        }
      }
    }
  }

  /* 可选的样式调整 */
  .elegant-dialog .el-dialog__footer {
    display: flex;
    justify-content: space-between;
  }
}

.upload-success-dialog {
  .upload-success-content {
    padding: 0 20px;

    .publish-tip {
      margin: 15px 0 10px;
      color: #606266;
    }

    .publish-link {
      font-size: 14px;
      margin-bottom: 20px;
      word-break: break-all;
    }

    .upload-details {
      margin-top: 20px;

      .detail-item {
        padding: 5px 0;
        font-size: 13px;
        color: #666;
        line-height: 1.5;
      }
    }
  }

  .dialog-btn {
    padding: 10px 20px;
  }
}
</style>